module.exports = __webpack_public_path__ + "img/result2.cad48efb.png";